import React, { FunctionComponent, useState } from 'react';
import EligibilityPoll from './EligibilityPoll';
import { AffiliationGroupForm } from '../../components/register';
import {
  EligibilityCheckResponse,
  EligibilityCheck,
} from '../../interfaces/register';
import { event } from '../../lib/analytics';
import { REGISTRATION } from '../../constants/events';

interface Props {
  eligibilityCheck: EligibilityCheckResponse;
}

const AffiliationGroupFormContainer: FunctionComponent<Props> = ({
  eligibilityCheck,
}: Props) => {
  const [
    isEligibilityCheckComplete,
    setIsEligibilityCheckComplete,
  ] = useState<boolean>(true);

  const handleComplete = () => setIsEligibilityCheckComplete(true);

  const handleSubmit = () => {
    setIsEligibilityCheckComplete(false);
    event({
      action: 'submit_group_insurance_eligibility_check',
      category: REGISTRATION,
      label: 'location',
      value: 'eligibility-error',
    });
  };

  const mapInitialValues = ({
    isDependent,
    ...rest
  }: EligibilityCheckResponse): EligibilityCheck => {
    return {
      isDependent: isDependent === 'true',
      ...rest,
    };
  };

  return (
    <EligibilityPoll
      key={eligibilityCheck.token}
      onSubmit={handleSubmit}
      onComplete={handleComplete}
      render={(eligibilityPoll) => (
        <AffiliationGroupForm
          selectedAffiliationName={eligibilityCheck.affiliationName}
          suggestedAffiliations={eligibilityCheck.groupList || []}
          initialValues={mapInitialValues(eligibilityCheck)}
          onSubmit={eligibilityPoll.onSubmit}
          disableSubmit={!isEligibilityCheckComplete}
        />
      )}
    />
  );
};

export default AffiliationGroupFormContainer;
